import { Link } from "react-router-dom";
import { fmtMoney } from "../lib/api";
import { MapPin, Bed, ArrowsOut } from "@phosphor-icons/react";

const MODE_LABEL = {
  sale: { t: "Vente", c: "bg-orange-800" },
  longterm: { t: "Location", c: "bg-slate-900" },
  event: { t: "Courte durée", c: "bg-amber-600" },
};

export const PropertyCard = ({ p, index = 0 }) => {
  const primaryMode = p.modes?.[0] || "sale";
  const price =
    primaryMode === "sale" ? p.sale_price :
    primaryMode === "longterm" ? p.monthly_rent :
    p.event_price_per_day;
  const suffix = primaryMode === "longterm" ? " /mois" : primaryMode === "event" ? " /jour" : "";
  const img = p.media?.[0] || "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

  return (
    <Link to={`/property/${p.id}`} data-testid={`property-card-${p.id}`}
      className="group block bg-white border border-stone-200 rounded-xl overflow-hidden hover:border-orange-300 hover:shadow-lg transition-[box-shadow,border-color] fade-up"
      style={{ animationDelay: `${index * 60}ms` }}>
      <div className="relative aspect-[4/3] overflow-hidden">
        <img src={img} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute top-3 left-3 flex gap-1.5">
          {p.modes?.map((m) => (
            <span key={m} className={`${MODE_LABEL[m]?.c} text-white text-[11px] font-semibold px-2.5 py-1 rounded-full`}>
              {MODE_LABEL[m]?.t}
            </span>
          ))}
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-1 text-stone-500 text-xs mb-1">
          <MapPin size={13} weight="fill" /> {p.city || "—"}
        </div>
        <h3 className="font-display text-lg font-semibold text-stone-900 leading-tight line-clamp-1">{p.title}</h3>
        <div className="flex items-center gap-4 text-stone-500 text-xs mt-2">
          <span className="flex items-center gap-1"><ArrowsOut size={14} />{p.surface || 0} m²</span>
          <span className="flex items-center gap-1"><Bed size={14} />{p.rooms || 0} pièces</span>
        </div>
        <div className="mt-3 pt-3 border-t border-stone-100">
          <span className="font-display text-xl font-bold text-orange-800">{fmtMoney(price)}</span>
          <span className="text-stone-400 text-sm">{suffix}</span>
        </div>
      </div>
    </Link>
  );
};
